export default __webpack_public_path__ + "static/media/logo-celo-icon.d1fed266.png";